
class Menu{
    defaultOptions() {
        return {
			'selector': '.doc-menu',
			'closerSelector': '.doc-menu-mobile-closer',
			'togglerSelector': '.doc-menu-mobile-toggler',
			'mainContainerSelector': 'body',

			'menuOpenedClass': 'mobile-menu-opened',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

		this.onClickClose = this.onClickClose.bind(this);
		this.onClickToggle = this.onClickToggle.bind(this);

		this.$menu = $(this.settings.selector);
		this.$closer = $(this.settings.closerSelector);
		this.$toggler = $(this.settings.togglerSelector);

		this.$mainContainer = $(this.settings.mainContainerSelector);

		
        this.initialize();
    }

	initialize(){
		var self = this;
		
		
		this.$closer.on('click',this.onClickClose);
		this.$toggler.on('click',this.onClickToggle);
		
		console.log("MEnu initialized",this);
	}

	onClickClose(){
		console.log("onClickClose",this);
		this.$mainContainer.removeClass(this.settings.menuOpenedClass);
	}

	onClickToggle(){
		console.log("onClickToggle",this);
		this.$mainContainer.addClass(this.settings.menuOpenedClass);
	}
}

module.exports = Menu;